export default {
  'dashboard.totalUsers': 'మొత్తం సక్రియ వినియోగదారులు',
  'dashboard.collectedEmis': 'వసూలు EMIలు',
  'dashboard.closedHps': 'మూసివేసిన HPలు',
  'dashboard.totalLoan': 'మొత్తం రుణ మొత్తం',
  'dashboard.vehiclesAvailable': 'అందుబాటులో ఉన్న వాహనాలు',
  'dashboard.vehiclesSold': 'అమ్మిన వాహనాలు',
  'dashboard.handLoans': 'చేతి రుణాలు',
  'dashboard.seizedHps': 'జప్తు HPలు',
  'dashboard.overview': 'అవలోకనం',
  'dashboard.exportReport': 'రిపోర్ట్ ఎగుమతి చేయండి',
  'dashboard.overviewSub': '{{range}} కోసం బ్యాలెన్స్‌లు మరియు థ్రూపుట్. ఖాతా వివరాలు మరియు డ్రిల్-డౌన్‌ల కోసం ఏ కార్డ్‌నైనా తెరవండి.',
  'dashboard.collectionsTrend': 'వసూళ్ల ధోరణి',
  'dashboard.collectionsTrendSub': 'EMI రసీదులు & ఆలస్య ఛార్జీలు నెలవారీగా — {{range}}',
  'dashboard.portfolioSplit': 'పోర్ట్‌ఫోలియో విభజన',
  'dashboard.topBorrowers': 'బకాయి ఆధారంగా అగ్ర రుణగ్రహీతలు',
  'dashboard.quickActions': 'త్వరిత చర్యలు',
  'dashboard.newFinance': 'కొత్త ఫైనాన్స్',
  'dashboard.newHandLoan': 'కొత్త చేతి రుణం',
  'dashboard.consultancyDesk': 'కన్సల్టెన్సీ డెస్క్',
  'dashboard.collected': 'వసూలు',
  'dashboard.noData': 'ఈ కాలంలో డేటా లేదు',

  'master.title': 'డాష్‌బోర్డ్',
  'master.financeIncome': 'ఫైనాన్స్ ఆదాయం',
  'master.totalRevenue': 'మొత్తం రెవెన్యూ',
  'master.interestCollectedHint': 'వసూలైన వడ్డీ',
  'master.revenueHint': 'వసూలైన వడ్డీ + ఆలస్య ఛార్జీలు',
  'master.interestWithYtdHint': 'కాల వడ్డీ + ఆలస్య ఛార్జీలు + YTD ఓపెనింగ్ సీడ్',
  'master.portfolioHint': 'యాక్టివ్ పోర్ట్‌ఫోలియో బాకీ',
  'master.borrowersHint': 'రుణగ్రహీతలు',
  'master.openingCash': 'చేతిలో నగదు',
  'master.openingBank': 'బ్యాంక్ బ్యాలెన్స్',
  'master.openingBooksHint': 'ఓపెనింగ్ బుక్స్ / కట్‌ఓవర్ నుండి',
  'master.liveCashHint': 'ఓపెనింగ్ నగదు + వసూళ్లు − రుణాలు, ఖర్చులు & అడ్వాన్స్‌లు',
  'master.liveBankHint': 'ఓపెనింగ్ బ్యాంక్ + క్రెడిట్ − డెబిట్ (కట్‌ఓవర్ తర్వాత)',
  'master.financeProfit': 'ఫైనాన్స్ లాభం',
  'master.profitFormula': 'రెవెన్యూ − ఖర్చులు',
  'master.netFormula': 'ఫైనాన్స్ రెవెన్యూ + కన్సల్టెన్సీ లాభం − ఖర్చులు',
  'master.emiCollected': 'మొత్తం EMI వసూలు',
  'master.cashBankHint': 'నగదు స్వీకరణ / బ్యాంక్ క్రెడిట్ = వసూళ్లు. నగదు ఇచ్చిన / బ్యాంక్ డెబిట్ = ఇచ్చిన రుణం.',
  'master.financeSectionHint': 'రెవెన్యూ = వసూలైన వడ్డీ + ఆలస్య ఛార్జీలు (+ YTD సీడ్ అప్లికబుల్ అయితే). లాభం = రెవెన్యూ − ఖర్చులు. EMI వసూలు = రుణ నగదు (రసీదల్లో అసలు + వడ్డీ).',
  'master.consultancySectionHint': 'వాహన అమ్మకాల డెస్క్ — ఎంచుకున్న కాలానికి రెవెన్యూ, ఖర్చు, లాభం.',
  'master.consultancyProfit': 'కన్సల్టెన్సీ లాభం',
  'master.expenses': 'మొత్తం ఖర్చులు',
  'master.netAccounting': 'నికర లాభం',
  'master.tabCombined': 'సంయుక్తం',
  'master.tabFinance': 'ఫైనాన్స్',
  'master.tabConsultancy': 'కన్సల్టెన్సీ',
  'master.incomeVsExpenses': 'రెవెన్యూ vs ఖర్చులు',
  'master.monthlyCollections': 'నెలవారీ వసూళ్లు & వడ్డీ',
  'master.revenueVsProfit': 'రెవెన్యూ vs లాభం',
  'master.spendByCategory': 'వర్గం వారీగా ఖర్చు',

  'accounts.title': 'అకౌంట్స్ & మైగ్రేషన్',
  'accounts.subtitle': 'మీ ఆర్థిక సంవత్సరం కోసం కటోవర్ తేదీ మరియు ఓపెనింగ్ బ్యాలెన్స్‌లు సెట్ చేయండి.',
  'accounts.howtoTitle': '3 దశల్లో గో-లైవ్',
  'accounts.howto1': 'కట్‌ఓవర్ తేదీ మరియు ఓపెనింగ్ బ్యాలెన్స్‌లు సెట్ చేయండి.',
  'accounts.howto2': 'ప్రతి యాక్టివ్ ఫైనాన్స్ / చేతి రుణాన్ని బకాయి + తదుపరి డ్యూ తో మైగ్రేట్ చేయండి.',
  'accounts.howto3': 'కట్‌ఓవర్ తర్వాత కొత్త చెల్లింపులు/ఖర్చులు ఈ సాఫ్ట్‌వేర్‌లోనే నమోదు చేయండి.',
  'accounts.tabOpening': 'ఓపెనింగ్ బుక్స్',
  'accounts.tabMigrateFinance': 'ఫైనాన్స్ మైగ్రేట్',
  'accounts.tabMigrateHand': 'చేతి రుణం మైగ్రేట్',
  'accounts.tabMigrated': 'మైగ్రేటెడ్ జాబితా',
  'accounts.openingHeading': 'కట్‌ఓవర్ నాటి ఓపెనింగ్ బ్యాలెన్స్‌లు',
  'accounts.cutoverDate': 'కట్‌ఓవర్ / గో-లైవ్ తేదీ',
  'accounts.cutoverHint': 'బుక్స్ మరియు మైగ్రేటెడ్ రుణాలు ఈ తేదీ నుండి ప్రారంభమవుతాయి.',
  'accounts.portfolioCheck': 'మైగ్రేట్ చేసిన రుణాల బకాయి',
  'accounts.booksOutstanding': 'బుక్స్ రుణాలు స్వీకరించదగినవి',
  'accounts.mismatchHint': 'సరిపోలడం లేదు',
  'accounts.matchedHint': 'సరిపోలుతుంది',
  'accounts.notes': 'మైగ్రేషన్ నోట్స్',
  'accounts.notesPlaceholder': 'ఉదా. పాత బుక్స్ నుండి మైగ్రేట్…',
  'accounts.saveOpening': 'ఓపెనింగ్ బుక్స్ సేవ్ చేయండి',
  'accounts.fillFromPortfolio': 'పోర్ట్‌ఫోలియో నుండి నింపండి',
  'accounts.migrateFinanceTitle': 'ఉన్న ఫైనాన్స్ సౌకర్యం మైగ్రేట్',
  'accounts.migrateFinanceHint': 'ఈరోజు స్థితి: బకాయి అసలు, మిగిలిన EMIలు, తదుపరి డ్యూ.',
  'accounts.migrateHandTitle': 'ఉన్న చేతి రుణం మైగ్రేట్',
  'accounts.migrateHandHint': 'బకాయి అసలు మరియు వడ్డీతో యాక్టివ్ చేతి రుణం తీసుకురండి.',
  'accounts.migrateWarning': 'పాత ప్రతి EMIని మళ్లీ నమోదు చేయవద్దు. కేవలం బకాయి + మిగిలిన షెడ్యూల్.',
  'accounts.saveMigratedFinance': 'మైగ్రేటెడ్ ఫైనాన్స్ సేవ్',
  'accounts.saveMigratedHand': 'మైగ్రేటెడ్ చేతి రుణం సేవ్',
  'accounts.migratedFinance': 'మైగ్రేటెడ్ ఫైనాన్స్',
  'accounts.migratedHand': 'మైగ్రేటెడ్ చేతి రుణాలు',
  'accounts.noneMigrated': 'ఇంకా మైగ్రేటెడ్ సౌకర్యాలు లేవు.',
  'accounts.openErpFy': 'Finance ERP తెరవండి',
  'accounts.erpSharedHint': 'నగదు, బ్యాంక్, క్యాపిటల్ వంటి ఓపెనింగ్ బ్యాలెన్స్‌లు Finance ERP → ఆర్థిక సంవత్సరంతో ఒకే ఫీల్డ్‌లు. ఇక్కడ సేవ్ చేస్తే అదే FY అప్‌డేట్ అవుతుంది.',
  'accounts.localOpeningHint': 'ఓపెనింగ్ బ్యాలెన్స్‌లు ఈ లెడ్జర్ బుక్‌కు సేవ్ అవుతాయి. finance లేదా audit యాక్సెస్ ఉంటే ERP సింక్ అందుబాటులో ఉంటుంది.',
  'accounts.fyBalancesHeading': 'ఆర్థిక సంవత్సర ఓపెనింగ్ (ERPతో షేర్)',
  'accounts.ytdHeading': 'ఐచ్ఛిక మిడ్-ఇయర్ P&L సీడ్స్ (Accounts మాత్రమే)',

  'customers.title': 'కస్టమర్లు',
  'customers.addHint': 'ఫైనాన్స్ కేసులు లేదా చేతి రుణాలు జోడించండి — ప్రతి సౌకర్యం ఇక్కడ రుణగ్రహీతతో లైవ్ బ్యాలెన్స్‌లతో కనిపిస్తుంది.',
  'customers.financeDesk': 'ఫైనాన్స్ డెస్క్',
  'customers.handLoans': 'చేతి రుణాలు',
  'customers.backOverview': 'అవలోకనానికి తిరిగి',
  'customers.totalPrincipal': 'మొత్తం మూలధనం',
  'customers.amountCollected': 'వసూలు మొత్తం',
  'customers.principalOutstanding': 'బకాయి మూలధనం',
  'customers.totalDue': 'మొత్తం చెల్లించాల్సిన మొత్తం',
  'customers.pageTitle': 'కస్టమర్లు',
  'customers.exportTitle': 'కస్టమర్ల రిపోర్ట్',
  'customers.filterFileStatus': 'ఫైల్ స్థితి',
  'customers.filterStatusAll': 'అన్ని ఫైళ్లు',
  'customers.filterActive': 'యాక్టివ్',
  'customers.filterClosed': 'క్లోజ్డ్',
  'customers.badgeActive': 'యాక్టివ్',
  'customers.badgeClosed': 'క్లోజ్డ్',

  'customer.tabOverview': 'అవలోకనం',
  'customer.tabHistory': 'చరిత్ర',
  'customer.tabAlerts': 'అలర్ట్‌లు',
  'customer.accountSummary': 'ఖాతా సారాంశం',
  'customer.overdueDays': 'ఆలస్యమైన రోజులు',
  'customer.unpaidOverdueDays': 'చెల్లించని ఆలస్య రోజులు',
  'customer.calculatedPenalty': 'లెక్కించిన పెనాల్టీ',
  'customer.loggedLateFees': 'బకాయి ఆలస్య ఛార్జీలు',
  'customer.lateFeesDue': 'బకాయి ఆలస్య ఛార్జీలు',
  'customer.lateFeesBalance': 'ఆలస్య బ్యాలెన్స్',
  'customer.noOverdue': 'ఈ కస్టమర్‌కు ఆలస్య రోజులు నమోదు లేవు.',
  'customer.viewMissedDates': 'మిస్ అయిన తేదీలు చూడండి',
  'customer.smsReminder': 'SMS రిమైండర్',
  'customer.cashIn': 'నగదు వచ్చింది',
  'customer.cashCollected': 'నగదు వసూలు',
  'customer.interestRecognized': 'గుర్తించిన వడ్డీ',
  'customer.ledgerInterest': 'వడ్డీ (లెడ్జర్ విభజనలు)',
  'customer.nextInstallment': 'తదుపరి వాయిదా',
  'customer.noUpcomingEmi': 'రాబోయే EMI లేదు – క్రింద ప్రతి సౌకర్యంలో కాలం మరియు EMI తనిఖీ చేయండి.',
  'customer.facilityTable': 'రుణ సౌకర్యాలు — EMIలు వసూలు',
  'customer.facilityTableSub': 'నెలలు, EMI మొత్తం, మరియు ప్రతి రుణం కోసం వసూలు',
  'customer.installmentSchedule': 'పూర్తి వాయిదా షెడ్యూల్',
  'customer.upcomingCashflow': 'నెలవారీగా రాబోయే నగదు ప్రవాహం',
  'customer.paymentHistory': 'చెల్లింపు చరిత్ర',
  'customer.alerts': 'అలర్ట్‌లు',
  'customer.recordPayment': 'EMIలు వసూలు',
  'customer.collectEmis': 'EMIలు వసూలు',
  'customer.emisComplete': 'EMIలు పూర్తి',
  'customer.collectionCol': 'వసూలు',
  'customer.closeFile': 'ఫైల్ మూసివేయండి',
  'customer.refinance': 'రీఫైనాన్స్',
  'customer.markSeized': 'జప్తు గా గుర్తించండి',
  'customer.due': 'చెల్లించాలి',
  'customer.facility': 'సౌకర్యం',
  'customer.kind': 'రకం',
  'customer.note': 'గమనిక',
  'customer.lateFee': 'ఆలస్య ఛార్జీ',
  'customer.balanceAfter': 'తర్వాత బ్యాలెన్స్',
  'customer.payoff': 'పూర్తి చెల్లింపు',

  'finance.newApplication': 'కొత్త అప్లికేషన్',
  'finance.noRows': 'మీ శోధనకు సరిపోలే పంక్తులు లేవు.',
  'finance.noRecords': 'ఇంకా ఫైనాన్స్ లేదు — ప్రత్యేక అప్లికేషన్ పేజీ తెరవడానికి కొత్త అప్లికేషన్ ఉపయోగించండి.',
  'finance.regHa': 'Reg / HA',
  'finance.customer': 'కస్టమర్',
  'finance.emi': 'EMI',
  'finance.currentFinances': 'ప్రస్తుత ఫైనాన్స్',
  'finance.editApplication': 'అప్లికేషన్ సవరించండి',
  'finance.stepVehicle': 'వాహనం',
  'finance.stepFinancial': 'ఆర్థిక',
  'finance.stepParties': 'పక్షాలు',
  'finance.backToList': 'జాబితాకు తిరిగి',
  'finance.saveApplication': 'అప్లికేషన్ సేవ్ చేయండి',

  'loans.borrower': 'రుణగ్రహీత',
  'loans.interest': 'వడ్డీ',
  'loans.term': 'కాలం',
  'loans.type': 'రకం',
  'loans.newApplication': 'కొత్త అప్లికేషన్',
  'loans.noRows': 'మీ శోధనకు సరిపోలే పంక్తులు లేవు.',
  'loans.noRecords': 'ఇంకా చేతి రుణాలు లేవు — ప్రత్యేక అప్లికేషన్ పేజీ తెరవడానికి కొత్త అప్లికేషన్ ఉపయోగించండి.',
  'loans.currentHandLoans': 'ప్రస్తుత చేతి రుణాలు',
  'loans.stepBorrower': 'రుణగ్రహీత',
  'loans.stepFacility': 'సౌకర్యం',
  'loans.repaymentEmi': 'EMI',
  'loans.repaymentShort': 'చిన్న కాలం',
  'loans.saveApplication': 'అప్లికేషన్ సేవ్ చేయండి',

  'reports.title': 'రిపోర్టులు',
  'reports.subtitle': 'ఎంచుకున్న కాలానికి ఫైనాన్స్ మరియు చేతి రుణ కార్యకలాపం.',
  'reports.loanType': 'రుణ రకం',
  'reports.serviceLine': 'సర్వీస్ లైన్',
  'reports.sortBy': 'క్రమబద్ధీకరించండి',
  'reports.financeCreated': 'ఫైనాన్స్ సృష్టించబడింది',
  'reports.handCreated': 'చేతి రుణాలు సృష్టించబడ్డాయి',
  'reports.financeClosed': 'ఫైనాన్స్ మూసివేయబడింది',
  'reports.handClosed': 'చేతి రుణాలు మూసివేయబడ్డాయి',
  'reports.financeSeized': 'ఫైనాన్స్ జప్తు',
  'reports.collections': 'వసూళ్లు',
  'reports.outstandingOverdue': 'బకాయి & ఆలస్యం',
  'reports.financeNew': 'కొత్త ఫైనాన్స్',
  'reports.financeClosedShort': 'ఫైనాన్స్ మూసివేయబడింది',
  'reports.seized': 'జప్తు',
  'reports.handNew': 'కొత్త చేతి రుణం',
  'reports.handClosedShort': 'చేతి రుణం మూసివేయబడింది',
  'reports.collected': 'వసూలు',
  'reports.lateFees': 'ఆలస్య ఛార్జీలు',
  'reports.openHps': 'తెరిచిన HPలు',
  'reports.amtDue': 'చెల్లించాల్సిన మొత్తం',
  'reports.regHa': 'Reg / HA',
  'reports.lateFee': 'ఆలస్య ఛార్జీ',
  'reports.menuLead': 'ఒక రిపోర్ట్ ఎంచుకోండి. అది సొంత పేజీలో తెరుచుకుంటుంది, అక్కడ నుండి Excel లేదా PDF డౌన్‌లోడ్ చేయవచ్చు.',
  'reports.allReports': 'అన్ని రిపోర్టులు',
  'reports.downloadHint': 'Excel లేదా PDF డౌన్‌లోడ్ చేయడానికి ఈ పేజీలో Export File ఉపయోగించండి.',
  'reports.groupBooks': 'నడుస్తున్న పుస్తకాలు',
  'reports.groupPeriod': 'ఎంచుకున్న కాలం',
  'reports.groupLedgers': 'అన్ని లెడ్జర్లు',
  'reports.periodSummary': 'కాల సారాంశం',
  'reports.consolidated': 'ఏకీకృత రిపోర్ట్',
  'reports.overdue': 'ఆలస్యం',
  'reports.outstanding': 'బకాయి నిల్వలు',
  'reports.descPeriod': 'ఎంచుకున్న కాలానికి సంఖ్యలు మరియు మొత్తాలు.',
  'reports.descConsolidated': 'లెడ్జర్ల వారీగా వసూళ్లు, వడ్డీ, ఖర్చులు మరియు నగదు ప్రవాహం.',
  'reports.descFinanceCreated': 'ఈ కాలంలో తెరిచిన ఫైనాన్స్ ఫైళ్లు.',
  'reports.descHandCreated': 'ఈ కాలంలో తెరిచిన చేతి రుణాలు.',
  'reports.descFinanceClosed': 'ఈ కాలంలో మూసిన ఫైనాన్స్ ఫైళ్లు.',
  'reports.descHandClosed': 'ఈ కాలంలో మూసిన చేతి రుణాలు.',
  'reports.descSeized': 'ఈ కాలంలో జప్తు చేసిన వాహనాలు.',
  'reports.descCollections': 'ఈ కాలంలో నమోదు చేసిన వసూళ్లు.',
  'reports.descLateFees': 'ఈ కాలంలో వసూలు చేసిన ఆలస్య ఛార్జీలు.',
  'reports.descOutstanding': 'తెరిచిన రుణాలపై ఇంకా వసూలు కావలసిన మొత్తం.',
  'reports.descOverdue': 'చెల్లింపు ఇప్పటికే ఆలస్యమైన రుణగ్రహీతలు.',
  'reports.noOverdue': 'ఆలస్యమైన రుణగ్రహీతలు లేరు.',
  'reports.noLateFees': 'ఈ కాలంలో ఆలస్య ఛార్జీలు లేవు.',

  'employees.title': 'ఉద్యోగులు & జీతం',
  'employees.subtitle': 'సిబ్బంది, జీతాలు మరియు అడ్వాన్స్‌లను నిర్వహించండి. {{range}} కోసం జీతం గణాంకాలు.',
  'employees.addEmployee': 'ఉద్యోగిని జోడించండి',
  'employees.activeStaff': 'సక్రియ సిబ్బంది',
  'employees.salaryPaid': 'జీతం చెల్లించబడింది',
  'employees.advancesGiven': 'ఇచ్చిన అడ్వాన్స్‌లు',
  'employees.outstandingAdvances': 'బకాయి అడ్వాన్స్‌లు',
  'employees.payrollReport': 'జీతం రిపోర్ట్',
  'employees.salary': 'జీతం',
  'employees.advances': 'అడ్వాన్స్‌లు',
  'employees.basic': 'బేసిక్',
  'employees.bonus': 'బోనస్',
  'employees.netPay': 'నికర జీతం',
  'employees.method': 'పద్ధతి',

  'expenses.title': 'ఖర్చులు',
  'expenses.subtitle': '{{range}} కోసం ఆపరేటింగ్ ఖర్చులను ట్రాక్ చేయండి.',
  'expenses.recordExpense': 'ఖర్చు నమోదు చేయండి',
  'expenses.categories': 'వర్గాలు',
  'expenses.totalSpend': 'మొత్తం ఖర్చు',
  'expenses.category': 'వర్గం',
  'expenses.vendor': 'విక్రేత',
  'expenses.description': 'వివరణ',
  'expenses.paidBy': 'చెల్లించినవారు',
  'expenses.paymentMethod': 'చెల్లింపు పద్ధతి',
  'expenses.addCategory': 'వర్గం జోడించండి',
  'expenses.spendByCategory': 'వర్గం వారీగా ఖర్చు',
  'expenses.expenseReport': 'ఖర్చు రిపోర్ట్',

  'consultancy.title': 'కన్సల్టెన్సీ',
  'consultancy.vehicles': 'వాహన ఇన్వెంటరీ',
  'consultancy.investment': 'పెట్టుబడి',
  'consultancy.revenue': 'రెవెన్యూ',
  'consultancy.profit': 'లాభం',
  'consultancy.loss': 'నష్టం',
  'consultancy.buyStock': 'స్టాక్ జోడించండి',
  'consultancy.sellStock': 'స్టాక్ నుండి అమ్మండి',
  'consultancy.available': 'అందుబాటులో',
  'consultancy.sold': 'అమ్మిన',
  'consultancy.all': 'అన్నీ',
  'consultancy.service': 'సేవ',
  'consultancy.transactionHistory': 'లావాదేవీ చరిత్ర',
  'consultancy.filtersSort': 'ఫిల్టర్‌లు మరియు క్రమబద్ధీకరణ',
  'consultancy.operationsDesk': 'ఆపరేషన్స్ డెస్క్',
  'consultancy.history': 'చరిత్ర',

  'portal.dueNow': 'ఇప్పుడు చెల్లించాలి',
  'portal.paid': 'చెల్లించబడింది',
  'portal.schedule': 'వాయిదా షెడ్యూల్',
  'portal.payments': 'చెల్లింపు చరిత్ర',
  'portal.totalLoan': 'మొత్తం రుణం',
  'portal.lateFee': 'ఆలస్య ఛార్జీ',
  'portal.lateDays': 'ఆలస్య రోజులు',
  'portal.paidEmis': 'చెల్లించిన EMIలు',
  'portal.pendingEmis': 'పెండింగ్ EMIలు',
  'portal.yourAccount': 'మీ ఖాతా',
  'portal.signOut': 'సైన్ అవుట్',
  'portal.allLoans': 'అన్ని రుణాలు',

  'navbar.latePayments': 'ఆలస్య చెల్లింపులు',
  'navbar.noLatePayments': 'ఆలస్య చెల్లింపులు లేవు',
  'navbar.notifications': 'నోటిఫికేషన్‌లు',
  'navbar.account': 'ఖాతా',
  'navbar.darkMode': 'డార్క్ మోడ్',
  'navbar.lightMode': 'లైట్ మోడ్',

  'hub.title': 'వర్క్‌స్పేస్ హోమ్',
  'hub.subtitle': 'అన్ని మాడ్యూల్‌లు ఒకే చోట — ఫైనాన్స్, వసూళ్లు, రిపోర్టులు మరియు సెట్టింగ్‌ల కోసం ఏ కార్డ్‌నైనా తెరవండి.',
  'hub.allModules': 'అన్ని మాడ్యూల్‌లు',
  'hub.modulesCount': 'మాడ్యూల్‌లు',
  'hub.modulesAria': 'అప్లికేషన్ మాడ్యూల్‌లు',
  'hub.backToModules': 'మాడ్యూల్‌లకు తిరిగి',
  'hub.accountingSummary': 'అకౌంటింగ్ సారాంశం',
  'hub.accountingTitle': 'P&L & నగదు ప్రవాహాలు',
  'hub.emiManagement': 'EMI నిర్వహణ',
  'hub.paymentsCollections': 'చెల్లింపులు & వసూళ్లు',
  'hub.overdueManagement': 'ఆలస్య నిర్వహణ',
  'hub.ledgers': 'లెడ్జర్లు',
  'hub.userManagement': 'వినియోగదారు నిర్వహణ',
  'hub.descOverview': 'పోర్ట్‌ఫోలియో KPIలు, వసూళ్ల ట్రెండ్‌లు మరియు రోజువారీ కార్యకలాపాలు.',
  'hub.descAccounting': 'కంబైన్డ్ P&L, ఫైనాన్స్ ఆదాయం, కన్సల్టెన్సీ లాభం, ఖర్చులు మరియు నగదు ప్రవాహాలు.',
  'hub.descCustomers': 'రుణగ్రహీత ప్రొఫైల్‌లు, EMI రసీదులు మరియు ఖాతా చరిత్ర.',
  'hub.descFinance': 'హైర్-పర్చేజ్ ఫైనాన్స్ సౌకర్యాలు సృష్టించండి మరియు నిర్వహించండి.',
  'hub.descHandLoans': 'అనువైన షరతులతో చేతి రుణాలు.',
  'hub.descEmi': 'చెల్లించాల్సిన కিস్తులు, రసీదులు మరియు EMI షెడ్యూల్‌లు.',
  'hub.descPayments': 'వసూళ్లు, నగదు/బ్యాంక్ విభజన మరియు చెల్లింపు చరిత్ర.',
  'hub.descOverdue': 'ఆలస్యమైన రుణగ్రహీతలు, ఆలస్య రోజులు మరియు జరిమానాలు.',
  'hub.descAccounts': 'ప్రారంభ పుస్తకాలు, మైగ్రేషన్ మరియు లైవ్ నగదు/బ్యాంక్ బ్యాలెన్స్‌లు.',
  'hub.descReports': 'రోజువారీ రిపోర్టులు, పోర్ట్‌ఫోలియో, వసూళ్లు మరియు ఆలస్య సారాంశాలు.',
  'hub.descAudit': 'లాగిన్‌లు, అప్‌డేట్‌లు మరియు భద్రతా ఈవెంట్‌ల లాగ్.',
  'hub.descErp': 'ట్రయల్ బ్యాలెన్స్, బ్యాలెన్స్ షీట్, P&L, డే బుక్ మరియు రికాన్సిల్.',
  'hub.descConsultancy': 'వాహన ఇన్వెంటరీ — కొనుగోలు, అమ్మకం, పెట్టుబడి మరియు లాభం.',
  'hub.descExpenses': 'వర్గం వారీga వ్యాపార ఖర్చులు ట్రాక్ చేయండి.',
  'hub.descEmployees': 'ఉద్యోగులు, జీతం, అడ్వాన్స్‌లు మరియు పేరోల్.',
  'hub.descLedgers': 'మల్టీ-బుక్ సెటప్ — లెడ్జర్లు సృష్టించండి మరియు లాగిన్‌లు కేటాయించండి.',
  'hub.descUsers': 'యజమానులు, అడ్మిన్‌లు, పాత్రలు మరియు అనుమతులు.',
  'hub.descSettings': 'కంపెనీ ప్రొఫైల్, బ్యాంక్‌లు, SMS, చెల్లింపులు, సబ్‌స్క్రిప్షన్ మరియు థీమ్.',
  'hub.statBorrowers': 'రుణగ్రహీతలు',
  'hub.statNetProfit': 'నికర లాభం',
  'hub.statCollectedMonth': 'ఈ నెల',
  'hub.statActiveFinance': 'ఫైనాన్స్ రికార్డ్‌లు',
  'hub.statActiveLoans': 'చేతి రుణాలు',
  'hub.statEmiDue': 'EMI బాకీ',
  'hub.statOverdue': 'ఆలస్యం',
  'hub.statActivityLog': 'కార్యకలాపం',
  'hub.statViewLog': 'లాగ్ చూడండి',
  'hub.statBooks': 'పుస్తకాలు',
  'hub.statFullSuite': 'పూర్తి సూట్',
  'hub.statEntries': 'ఎంట్రీలు',
  'hub.statStaff': 'సిబ్బంది',
  'hub.statAccess': 'ప్రవేశం',
  'hub.statTeamRoles': 'టీమ్ & పాత్రలు',
  'hub.statWorkspace': 'వర్క్‌స్పేస్',
  'hub.statConfigure': 'కాన్ఫిగర్',
} as const;
